/**
 * Carousel Component
 * @module patterns/components/banners/asset-hero-banner
 */

import { type App } from '~/app';

import Glide from '@glidejs/glide';

import JsController from '../js-controller';

export default (app: App) => {

    const controller = new JsController(app, 'feature-cards-component');
    controller.addMountFunction(() => {
        mountFeatureCardComponent(controller);
    })

    return controller.init();
}

export function mountFeatureCardComponent( controller: JsController ) {
    const offerTilesCarouselComponents = document.querySelectorAll<HTMLElement>('.featured-cards-carousel-component');
    for (const carousel of offerTilesCarouselComponents) {

        const carouselGlide = new Glide(carousel, {
            type:'slider',
            perView: 1,
            startAt: 0,
            gap: 16,
            peek:{ before: 36, after: 36}
        });

        setTimeout(() => {
            // Timeout to load clone slides
            carouselGlide.mount();
        }, 800);
        controller.addCarouselInstance(carouselGlide);
}
}